export const ExternalLinks = {
  footer: {
    contract: 'https://docs.google.com/document/d/1SUbWbpag1GBwuOOaYcpdtHlmUM4p8c6b',
    phoneNumber: '0 (800) 35-14-53',
    supportEmail: 'support@ukasko.com.ua',
  },
};
